module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js??ref--1-oneOf-1!../../../../node_modules/eslint-loader/index.js??ref--0-0!./index.js"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./src/pages/comment/PageCommentList/index.js
// module id = 948
// module chunks = 97